import * as Yup from 'yup';

const maxFileSize = 1048576;

const matchFileFormat = (name, availableFormats) => {
  const fileFormat = name.split('.').pop();

  return availableFormats.includes(fileFormat);
};

const portfolioUploadSchema = (
  availableFormats,
  fileExistenceMessage = 'Portoflio file is required',
) =>
  Yup.object().shape({
    fileUploadInput: Yup.mixed()
      .test('fileExistence', fileExistenceMessage, value => value)
      .test('fileSize', 'File too large', value => value && value.size <= maxFileSize)
      .test(
        'fileFormat',
        'Unsupported format',
        value => value && matchFileFormat(value.name.toLowerCase(), availableFormats),
      ),
  });

export { portfolioUploadSchema };
